'use client'

import SportPage from '@/components/organisms/sportPage'

const PadelUbudPage = ({ pageAPI, testimonials, padelPricing, footerAPI, settingAPI }) => (
  <SportPage sport="PADEL" pageAPI={pageAPI} testimonials={testimonials} pricing={padelPricing?.padel}
    footerAPI={footerAPI} settingAPI={settingAPI} />
)

export default PadelUbudPage
